import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { facebookAuthCallbackRequest } from '../redux/slices/integrationsSlice';
import { ENDPOINTS } from '../api/endPoints';

export const useTikTokAuth = () => {
  const dispatch = useDispatch();

  const startTikTokAuth = useCallback(async () => {
    const authorizeUrl = ENDPOINTS.integrations.authorize('tiktok');
    
    if (!authorizeUrl) {
      throw new Error('TikTok authorization endpoint not configured');
    }

    // Store platform in sessionStorage so callback knows which platform this is
    sessionStorage.setItem('oauth_platform', 'tiktok');

    const popup = window.open(authorizeUrl, 'tiktok_oauth', 'width=600,height=700');

    if (!popup || popup.closed || typeof popup.closed === 'undefined') {
      window.location.href = authorizeUrl;
      return;
    }

    try {
      const result = await waitForAuthMessage(dispatch);
      return result;
    } catch (err) {
      console.error('TikTok auth failed:', err);
      throw err;
    }
  }, [dispatch]);

  return { startTikTokAuth };
};

function waitForAuthMessage(dispatch: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const handler = (event: MessageEvent) => {
      const { type, payload } = event.data || {};

      if (type === 'tiktok_AUTH_SUCCESS') {
        cleanup();
        
        // Dispatch Redux action to call the backend API with platform
        dispatch(facebookAuthCallbackRequest({
          ...payload,
          platform: 'tiktok'
        }));
        
        resolve(payload);
      }

      if (type === 'tiktok_AUTH_ERROR') {
        cleanup();
        reject(payload);
      }
    };

    const cleanup = () => {
      window.removeEventListener('message', handler);
      clearTimeout(timeout);
    };

    const timeout = setTimeout(() => {
      cleanup();
      reject('Timeout');
    }, 60000);

    window.addEventListener('message', handler);
  });
}
